import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { api } from '../api.js'
import Layout from '../componentes/Layout.jsx'
import { Campo, Erro, NOME_PROPULSAO } from '../componentes/basicos.jsx'

const PROPULSOES = ['eletrico', 'combustao', 'flex', 'phev']
const COMBUSTIVEIS = ['gasolina', 'etanol', 'diesel', 'gnv']

/**
 * Cadastro de veículo em página própria: a garagem é a lista, e cadastrar é uma
 * ação de vez em quando. Misturar o formulário com a lista fazia o que se usa
 * todo dia competir com o que se usa uma vez por carro.
 */
export default function NovoVeiculo() {
  const navegar = useNavigate()
  const [form, setForm] = useState({
    nome: '', propulsao: 'eletrico', combustivel: '', odometro_inicial: '',
    capacidade_bateria_kwh: '', capacidade_tanque_l: '',
  })
  const [erro, setErro] = useState(null)
  const [salvando, setSalvando] = useState(false)

  // Combustão exige combustível; PHEV aceita opcionalmente; elétrico não tem.
  const pedeCombustivel = form.propulsao === 'combustao' || form.propulsao === 'phev'
  const temBateria = form.propulsao === 'eletrico' || form.propulsao === 'phev'
  const temTanque = form.propulsao !== 'eletrico'
  const numero = (t) => (t === '' ? null : Number(String(t).replace(',', '.')))

  async function criar(evento) {
    evento.preventDefault()
    setSalvando(true)
    setErro(null)
    try {
      await api.post('/veiculos', {
        nome: form.nome,
        propulsao: form.propulsao,
        combustivel: pedeCombustivel && form.combustivel ? form.combustivel : null,
        odometro_inicial: Number(form.odometro_inicial || 0),
        ...(temBateria ? { capacidade_bateria_kwh: numero(form.capacidade_bateria_kwh) } : {}),
        ...(temTanque ? { capacidade_tanque_l: numero(form.capacidade_tanque_l) } : {}),
      })
      navegar('/garagem', { replace: true })
    } catch (e) {
      setErro(e)
    } finally {
      setSalvando(false)
    }
  }

  return (
    <Layout titulo="Novo veículo">
      <form className="cartao pilha" onSubmit={criar}>
        <Campo rotulo="Nome" dica="Como você chama o carro no dia a dia.">
          <input value={form.nome} required autoFocus
                 onChange={(e) => setForm({ ...form, nome: e.target.value })} />
        </Campo>

        <Campo rotulo="Propulsão"
               dica="Define como o consumo é calculado e não pode ser mudada depois.">
          <select value={form.propulsao}
                  onChange={(e) => setForm({ ...form, propulsao: e.target.value })}>
            {PROPULSOES.map((p) => <option key={p} value={p}>{NOME_PROPULSAO[p]}</option>)}
          </select>
        </Campo>

        {pedeCombustivel && (
          <Campo rotulo="Combustível"
                 dica={form.propulsao === 'phev'
                   ? 'Opcional: sem escolher, aceita gasolina e etanol.'
                   : undefined}>
            <select value={form.combustivel} required={form.propulsao === 'combustao'}
                    onChange={(e) => setForm({ ...form, combustivel: e.target.value })}>
              <option value="">Selecione…</option>
              {COMBUSTIVEIS.map((c) => <option key={c} value={c}>{c}</option>)}
            </select>
          </Campo>
        )}

        <Campo rotulo="Odômetro atual (km)"
               dica="Ponto de partida das contas. Use 0 se comprou novo e quer contar desde o começo.">
          <input inputMode="numeric" value={form.odometro_inicial}
                 onChange={(e) => setForm({ ...form, odometro_inicial: e.target.value })} />
        </Campo>

        {temBateria && (
          <Campo rotulo="Capacidade da bateria (kWh)" dica="Opcional.">
            <input inputMode="decimal" value={form.capacidade_bateria_kwh}
                   onChange={(e) => setForm({ ...form, capacidade_bateria_kwh: e.target.value })} />
          </Campo>
        )}

        {temTanque && (
          <Campo rotulo="Capacidade do tanque (L)" dica="Opcional.">
            <input inputMode="decimal" value={form.capacidade_tanque_l}
                   onChange={(e) => setForm({ ...form, capacidade_tanque_l: e.target.value })} />
          </Campo>
        )}

        <Erro erro={erro} />

        <div className="linha">
          <button type="submit" className="botao-principal crescer" disabled={salvando}>
            {salvando ? 'Cadastrando…' : 'Cadastrar veículo'}
          </button>
          <Link className="botao botao-fantasma" to="/garagem">Cancelar</Link>
        </div>
      </form>
    </Layout>
  )
}
